import Input from "../../controls/Input";
import SelectMenu from "../../controls/SelectMenu";
import { useForm } from "../useForm";
import { useEffect, useState } from "react";
import {
  cycleCountStatusOptions,
  formatDateWithTime,
  isReadOnlyUser,
} from "../../../shared/utility";
import CycleCountItemsInRightPlace from "./CycleCountItemsInRightPlace";
import ButtonDropdown from "../../controls/ButtonDropdown";
import ButtonSpinner from "../../controls/ButtonSpinner";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const initialFValues = {
  name: "",
  correct_items: [],
  wrong_items: [],
  items_missing: [],
  cycle_status: { value: -1, label: "" },
};

export default function CycleCountDetailsForm(props) {
  const {
    cycleCount,
    updateCycleCountStatus,
    printCycleCountSummary,
    printMissingItems,
    printCycleCountDetails,
    askDeleteCycleCount,
    askRelocateItem,
    selectedRelocationItems,
    setSelectedRelocationItems,
    relocateInProgress,
    askRelocateMultipleItems,
    selectedMissingItems,
    setSelectedMissingItems,
    askMarkItemMissing,
    askDeleteShippedItemsFromCC,
    askUnlockLockedItems,
    selectedShippingItems,
    setSelectedShippingItems,
    selectedLockedItems,
    setSelectedLockedItems,
    getCorrectItemsGroupedByPlu,
    getWrongItemsGroupedByPlu,
    getMissingItemsGroupedByPlu,
    getShippedItemsGroupedByPlu,
    getLockedItemsGroupedByPlu,
  } = props;

  const [correctItemsSearch, setCorrectItemsSearch] = useState("");
  const [wrongItemsSearch, setWrongItemsSearch] = useState("");
  const [missingItemsSearch, setMissingItemsSearch] = useState("");
  const [shippedItemsSearch, setShippedItemsSearch] = useState("");
  const [lockedItemsSearch, setLockedItemsSearch] = useState("");

  const buttonOptions = [
    {
      name: "Summary Report",
      onClick: printCycleCountSummary,
      inProgress: false,
    },
    {
      name: "Detailed Report",
      onClick: printCycleCountDetails,
      inProgress: false,
    },
    {
      name: "Missing Items Report",
      onClick: printMissingItems,
      inProgress: false,
    },
  ];

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  useEffect(() => {
    var statusSelected = [];
    statusSelected = cycleCountStatusOptions.find(
      (el) => el.value === cycleCount.status
    );

    setValues({ ...cycleCount, cycle_status: statusSelected });
  }, [cycleCount]);

  async function searchCorrectLocationItems() {
    const results = await getCorrectItemsGroupedByPlu(correctItemsSearch);
    if (results.success) {
      setValues((prevValues) => ({
        ...prevValues,
        correct_items: results.data,
      }));
    }
  }

  async function searchWrongLocationItems() {
    const results = await getWrongItemsGroupedByPlu(wrongItemsSearch);
    if (results.success) {
      setValues((prevValues) => ({ ...prevValues, wrong_items: results.data }));
    }
  }

  async function searchMissingLocationItems() {
    const results = await getMissingItemsGroupedByPlu(missingItemsSearch);
    if (results.success) {
      setValues((prevValues) => ({
        ...prevValues,
        items_missing: results.data,
      }));
    }
  }

  async function searchShippedLocationItems() {
    const results = await getShippedItemsGroupedByPlu(shippedItemsSearch);
    if (results.success) {
      setValues((prevValues) => ({
        ...prevValues,
        shipped_items: results.data,
      }));
    }
  }

  async function searchLockedLocationItems() {
    const results = await getLockedItemsGroupedByPlu(lockedItemsSearch);
    if (results.success) {
      setValues((prevValues) => ({
        ...prevValues,
        locked_items: results.data,
      }));
    }
  }

  return (
    <div className="justify-between">
      <div className="hide-for-print">
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Cycle count: {cycleCount.name}
            </h3>
          </div>

          <div className="flex">
            {!isReadOnlyUser() && (
              <ButtonDropdown
                items={buttonOptions}
                mainOption="Save"
                mainAction={() =>
                  updateCycleCountStatus({
                    status: values.cycle_status.value,
                  })
                }
              />
            )}
            {/* <button
              className="ml-3 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
              onClick={() => askDeleteCycleCount()}
            >
              Delete
            </button> */}
          </div>
        </div>
      </div>

      <div className="pt-6 pb-5 grid grid-cols-1 gap-2">
        <div className="p-4 card-custom space-y-5">
          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Created by"
              name="created_by_name"
              value={values.created_by_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Date"
              name="created_at"
              value={formatDateWithTime(values.created_date)}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Location"
              name="warehouse_location_name"
              value={values.warehouse_location_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="cycle_status"
              options={cycleCountStatusOptions}
              value={values.cycle_status}
              title={"Status"}
              error={errors.cycle_status}
            />
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <div>
          <div className="flex">
            <h3 className="my-auto">
              Items in correct location: {values.correct_items_total_cartons}
            </h3>
            <div className="ml-4 relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="searchCorrectItems"
                id="searchCorrectItems"
                className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                placeholder="Search by barcode"
                onKeyDown={(e) =>
                  e.key === "Enter" ? searchCorrectLocationItems() : null
                }
                onChange={(e) => setCorrectItemsSearch(e.target.value)}
                value={correctItemsSearch}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
              onClick={() => searchCorrectLocationItems()}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
        <CycleCountItemsInRightPlace
          items={values.correct_items}
          type={1}
          multiActionCall={() => {}}
          selectedItems={[]}
          setSelectedItems={() => {}}
          cycleId={values.id}
          warehouseLocationId={values.warehouse_location_id}
          search={correctItemsSearch}
        />
      </div>

      <div>
        <div>
          <div className="flex">
            <h3 className="my-auto">
              Items in wrong location: {values.wrong_items_total_cartons}
            </h3>
            <div className="ml-4 relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="searchCorrectItems"
                id="searchCorrectItems"
                className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                placeholder="Search by barcode"
                onKeyDown={(e) =>
                  e.key === "Enter" ? searchWrongLocationItems() : null
                }
                onChange={(e) => setWrongItemsSearch(e.target.value)}
                value={wrongItemsSearch}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
              onClick={() => searchWrongLocationItems()}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </button>
            {!isReadOnlyUser() && (
              <button
                onClick={() => {
                  askRelocateMultipleItems();
                }}
                className="ml-4 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 right"
              >
                <ButtonSpinner spin={relocateInProgress} text="Relocate" />
              </button>
            )}
          </div>
        </div>
        <CycleCountItemsInRightPlace
          items={values.wrong_items}
          type={2}
          multiActionCall={askRelocateItem}
          multiActionText="Relocate"
          selectedItems={selectedRelocationItems}
          setSelectedItems={setSelectedRelocationItems}
          cycleId={values.id}
          warehouseLocationId={values.warehouse_location_id}
          search={wrongItemsSearch}
        />
      </div>

      <div className="pb-10">
        <div className="flex">
          <h3 className="my-auto">
            Items missing in location: {values.items_missing_total_cartons}
          </h3>
          <div className="ml-4 relative flex items-stretch flex-grow focus-within:z-10">
            <input
              type="search"
              name="searchCorrectItems"
              id="searchCorrectItems"
              className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
              placeholder="Search by barcode"
              onKeyDown={(e) =>
                e.key === "Enter" ? searchMissingLocationItems() : null
              }
              onChange={(e) => setMissingItemsSearch(e.target.value)}
              value={missingItemsSearch}
            />
          </div>
          <button
            type="button"
            className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
            onClick={() => searchMissingLocationItems()}
          >
            <MagnifyingGlassIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </button>
          {!isReadOnlyUser() && (
            <button
              onClick={() => {
                askMarkItemMissing();
              }}
              className="ml-4 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 right"
            >
              <ButtonSpinner spin={relocateInProgress} text="Mark Missing" />
            </button>
          )}
        </div>
        <CycleCountItemsInRightPlace
          items={values.items_missing}
          type={3}
          multiActionCall={() => {}}
          selectedItems={selectedMissingItems}
          setSelectedItems={setSelectedMissingItems}
          cycleId={values.id}
          warehouseLocationId={values.warehouse_location_id}
          search={missingItemsSearch}
        />
      </div>

      <div className="pb-10">
        <div className="flex">
          <h3 className="my-auto">
            Items shipped in location: {values.shipped_items_total_cartons}
          </h3>
          <div className="ml-4 relative flex items-stretch flex-grow focus-within:z-10">
            <input
              type="search"
              name="searchCorrectItems"
              id="searchCorrectItems"
              className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
              placeholder="Search by barcode"
              onKeyDown={(e) =>
                e.key === "Enter" ? searchShippedLocationItems() : null
              }
              onChange={(e) => setShippedItemsSearch(e.target.value)}
              value={shippedItemsSearch}
            />
          </div>
          <button
            type="button"
            className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
            onClick={() => searchShippedLocationItems()}
          >
            <MagnifyingGlassIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </button>
          {!isReadOnlyUser() && (
            <button
              onClick={() => {
                askDeleteShippedItemsFromCC();
              }}
              className="ml-4 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 right"
            >
              <ButtonSpinner spin={false} text="Delete" />
            </button>
          )}
        </div>
        <CycleCountItemsInRightPlace
          items={values.shipped_items}
          type={4}
          multiActionCall={askDeleteShippedItemsFromCC}
          multiActionText="Delete"
          selectedItems={selectedShippingItems}
          setSelectedItems={setSelectedShippingItems}
          cycleId={values.id}
          warehouseLocationId={values.warehouse_location_id}
          search={shippedItemsSearch}
        />
      </div>

      <div className="pb-10">
        <div className="flex">
          <h3 className="my-auto">
            Items locked in location: {values.locked_items_total_cartons}
          </h3>
          <div className="ml-4 relative flex items-stretch flex-grow focus-within:z-10">
            <input
              type="search"
              name="searchCorrectItems"
              id="searchCorrectItems"
              className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
              placeholder="Search by barcode"
              onKeyDown={(e) =>
                e.key === "Enter" ? searchLockedLocationItems() : null
              }
              onChange={(e) => setLockedItemsSearch(e.target.value)}
              value={lockedItemsSearch}
            />
          </div>
          <button
            type="button"
            className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
            onClick={() => searchLockedLocationItems()}
          >
            <MagnifyingGlassIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </button>
          {!isReadOnlyUser() && (
            <button
              onClick={() => {
                askUnlockLockedItems();
              }}
              className="ml-4 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 right"
            >
              <ButtonSpinner spin={false} text="Unlock" />
            </button>
          )}
        </div>
        <CycleCountItemsInRightPlace
          items={values.locked_items}
          type={5}
          multiActionCall={askUnlockLockedItems}
          multiActionText="Unlock"
          selectedItems={selectedLockedItems}
          setSelectedItems={setSelectedLockedItems}
          cycleId={values.id}
          warehouseLocationId={values.warehouse_location_id}
          search={lockedItemsSearch}
        />
      </div>
    </div>
  );
}
